<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <h4>{{ title }} <span v-if="FabricName !== '' && FabricName">({{FabricName}})</span></h4>
      </v-flex>
      <v-flex xs12>
        <div v-if="error" class="red--text">Please select {{ title }}</div>
      </v-flex>
      <v-flex xs4 v-for="(fabric, index) in fabrics" :key="index" @click="selectFabric(fabric._id, fabric.weighted)">
        <v-card :flat="selectedFabric != fabric._id" class="tile">
          {{ fabric.name }}
        </v-card>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </div>
</template>
<script>
import FabricService from '@/services/FabricService'

export default {
  props: {
    fabricGroupID: {
      required: true
    },
    value: {
      default: ''
    },
    title: {
      default: 'Fabrics'
    },
    error: false,
    pelmetType: '',
    FabricName: ''
  },
  mounted () {
    this.getFabrics(this.fabricGroupID)
  },
  data () {
    return {
      fabrics: null,
      selectedFabric: null
    }
  },
  watch: {
    fabricGroupID: function (val) {
      this.getFabrics(val)
    },
    value: function (val) {
      val = val._id ? val._id : val
      this.selectedFabric = val
    }
  },
  methods: {
    async getFabrics (fabricGroupID) {
      const response = await FabricService.getFabricsByGroup(fabricGroupID)
      this.fabrics = response.data.fabrics
      if (this.pelmetType === 'Bonded') {
        this.fabrics = this.fabrics.filter(function (fabric) {
          return !['Qube', 'Focus', 'Solitaire', 'Vivid Block'].includes(fabric.name)
        })
      }
    },

    selectFabric (id, weighted) {
      this.selectedFabric = id
      this.$emit('selected-fabric', id)
      this.$emit('weighted', weighted)
    }
  }
}
</script>
<style scoped>
  .tile {
    text-align: center;
    padding: 10px;
    overflow: hidden;
    cursor: pointer;
    border: solid 1px #ccc !important;
  }

  .tile.elevation-2 {
    border-color: #e83b68 !important;
  }

  .tile:not(.v-card--flat) {
    border-color: #e83b68 !important;
  }

  .tile:hover {
    background: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/FabricSelector.vue